import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeLatest,
} from "redux-saga/effects";
import {
  getRoleAccess,
  getUserInfo as getUserInfoApiReq,
  getUserPlan,
  getUserStores,
} from "src/tabs/auth/api-client";
import {
  GET_USER_PLAN_REQUEST,
  GET_USER_STORES_REQUEST,
  INITIALIZE,
  setActiveStore,
  setInitialized,
  USER_INFO_REQUEST_SUCCEED,
  USER_STORES_REQUEST_SUCCEED,
  userInfoRequest,
  userInfoRequestFailed,
  userInfoRequestSucceed,
  userPlanRequest,
  userPlanRequestFailed,
  userPlanRequestSucceed,
  userRoleAccessRequest,
  userRoleAccessRequestFailed,
  userRoleAccessRequestSucceed,
  userStoreRequest,
  userStoreRequestFailed,
  userStoreRequestSucceed,
} from "../actions/app";
import {
  getUserRole,
  getUserRoleForStore,
  getUserStoresData,
} from "../selectors/app";

export function* userSaga() {
  yield all([
    takeLatest("HELLO_WORLD", handleHelloWorld),
    takeLatest(INITIALIZE, handleInitialization),
    takeLatest(GET_USER_PLAN_REQUEST, handleGetUserPlans),
    takeLatest(GET_USER_STORES_REQUEST, handleGetUserStores),
  ]);
}

function handleHelloWorld() {
  console.log("Hello World action - received");
}

function* handleInitialization() {
  //app will be initialized here
  yield fork(handleGetUserInfo);
  yield take(USER_INFO_REQUEST_SUCCEED);
  const userRole = yield select(getUserRole);

  if (userRole !== 1) {
    yield fork(handleGetUserStores);
    yield fork(handleGetUserPlans);
    yield take(USER_STORES_REQUEST_SUCCEED);

    const stores = yield select(getUserStoresData);
    if (stores.length !== 0) {
      yield put(setActiveStore(stores[0]?.id));
    }
  }
  yield call(handleGetRoleAccess);

  yield put(setInitialized(true));
}

function* handleGetUserInfo() {
  try {
    yield put(userInfoRequest());
    const res = yield call(getUserInfoApiReq);
    yield put(userInfoRequestSucceed(res.data));
  } catch (err) {
    yield put(userInfoRequestFailed(err));
  }
}

function* handleGetRoleAccess() {
  try {
    const userInfo = yield select(getUserRoleForStore);
    yield put(userRoleAccessRequest());
    const res = yield call(getRoleAccess, Number(userInfo));
    yield put(userRoleAccessRequestSucceed(res.data));
  } catch (err) {
    yield put(userRoleAccessRequestFailed(err));
  }
}

function* handleGetUserStores() {
  try {
    yield put(userStoreRequest());
    const res = yield call(getUserStores);
    yield put(userStoreRequestSucceed(res.data));
  } catch (err) {
    yield put(userStoreRequestFailed(err));
  }
}

function* handleGetUserPlans() {
  try {
    yield put(userPlanRequest());
    const res = yield call(getUserPlan);
    yield put(userPlanRequestSucceed(res.data));
  } catch (err) {
    yield put(userPlanRequestFailed(err));
  }
}
